import { createContext, useContext } from 'react';

export const AgentContext = createContext<number>(NaN);

const useAgentId = () => useContext(AgentContext);

export default useAgentId;
